<ng-template #template let-row="row">
  <div class="project-property-type-cell">
    @if (row?.basicDataBox?.propertyType) {
      <div class="project-property-type-cell__tile">
        {{ 'Projects.PropertyType.' + row?.basicDataBox?.propertyType | translate }}
      </div>
    } @else {
      <span>-</span>
    }
  </div>
</ng-template>
